import { inject, InjectionToken } from '@angular/core';
import { ISvcActionPlanHistoryRepository } from '../repositories/svc-action-plan-history.repository.interface';
import { SvcActionPlanHistoryHttpRepository } from '../repositories/svc-action-plan-history-http.repository';

export const SVC_ACTION_PLAN_HISTORY_REPOSITORY = new InjectionToken<ISvcActionPlanHistoryRepository>('SVC_ACTION_PLAN_HISTORY_REPOSITORY', {
    providedIn: 'root',
    factory: () => inject(SvcActionPlanHistoryHttpRepository),
});
